import { errorHandler } from '@/lib/ErrorHandler';
import { getClient } from '@/lib/restClient';
import { UpdateMenuSet } from '@/pages/menu-managements/allocated-menus/service';
import { MenuManagementAllocatedMenuService } from '@/services/AllocatedMenu/MenuManagementAllocatedMenuService';

export type MenuManagementAllocatedMenuUpdateParams = {
  master_store_id: number;
  menu_sets: UpdateMenuSet[];
};

export const useMenuManagementUpdateAllocatedMenu = async (
  params: MenuManagementAllocatedMenuUpdateParams
): Promise<void> => {
  const menuManagementAllocatedMenuService =
    new MenuManagementAllocatedMenuService(getClient());

  return menuManagementAllocatedMenuService
    .put(params)
    .catch((error: Error) => errorHandler({ error }));
};
